import { useState,useEffect, useContext, useReducer } from 'react';
import {db} from './FirebaseConfig';
import { Avatar, Button } from '@material-ui/core';
import FavoriteBorderOutlinedIcon from '@material-ui/icons/FavoriteBorderOutlined';
import ModeCommentOutlinedIcon from '@material-ui/icons/ModeCommentOutlined';
import firebase from 'firebase';
import './styles/Post.css';
import { AuthContext } from './context';

const Post = ({ postId, username, caption, image}) => {

    const [comments, setComments] = useState([]);
    const [comment, setComment] = useState('');
    const [likes, setLikes] = useState([]);
    const { user } = useContext(AuthContext);
   

    //for comments
    useEffect(() => {
        let unsubscribe;
        if(postId){
            unsubscribe = db.collection('posts')
                            .doc(postId)
                            .collection('comments')
                            .orderBy('timestamp', 'desc')
                            .onSnapshot((snapshot) => {
                                setComments(snapshot.docs.map(doc => (
                                    doc.data()
                                )));
                            })
        }

        return () => {
            unsubscribe();
        }
    }, [postId]);

    //for likes
    useEffect(() => {
        let unsubscribe;
        if(postId){
            unsubscribe = db.collection('posts')
                            .doc(postId)
                            .collection('likes')
                            .orderBy('timestamp', 'desc')
                            .onSnapshot((snapshot) => {
                                setLikes(snapshot.docs.map(doc => (
                                    doc.data()
                                )));
                            })
        }

        return () => {
            unsubscribe();
        }
    }, [postId, user]);

    const postLike = e => {
        if(user){
            e.preventDefault();
            let flag = 0;
            var i = 0;

            for(i = 0; i < likes.length ; i++){
                if(likes[i].username === user.displayName){
                    flag = 1;
                    break;
                }
            }

            if(flag === 0){
                db.collection('posts').doc(postId).collection('likes').add({
                    username : user.displayName,
                    timestamp : firebase.firestore.FieldValue.serverTimestamp()
                });
            }
            else{
                //open popover
            }
        }
    } 
    
    const postComment = e => {
        e.preventDefault();

        db.collection('posts').doc(postId).collection('comments').add({
            text : comment,
            username : user.displayName,
            timestamp : firebase.firestore.FieldValue.serverTimestamp()
        });
        setComment('');
    } 



    return(
        <div className = 'post'>

            <div className = 'post_header'>
                <Avatar 
                    className = 'post_avatar'
                    alt = {username}
                    src = 'random'
                />
                <h3>{username}</h3>
            </div>
            
            <img className = 'post_image' src = {image} alt = 'image'></img>
            
            <div className = 'post_metrics'>
                <Button disableRipple = {!user} onClick = {postLike}><FavoriteBorderOutlinedIcon className = 'post_metricsLikes'/>{likes.length}</Button>
                <Button disableRipple = {true}><ModeCommentOutlinedIcon className = 'post_metricsComments'/>{comments.length}</Button>
            </div>
            
            <h4 className = 'post_text'> <strong>{username}</strong> {caption}</h4>

            <div className = 'post_comments'>
                {
                    comments.map(comment => (
                        <p>
                            <strong>{comment.username}</strong> {comment.text}
                        </p>
                    ))
                }
            </div>

            {user && (
                <form className = 'post_commentBox'>
                    <input className = 'post_input'
                           type = 'text'
                           placeholder = 'Add a comment...'
                           value = {comment}
                           onChange = {(e) => setComment(e.target.value)}/>
                    <button className = 'post_button' disabled = {!comment} type = 'submit' onClick = {postComment}>
                        Post
                    </button>
                </form>
            )}
            
        </div>
    );
}

export default Post;